export default "__VITE_ASSET__B7FtIUsv__"